import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Copy } from "lucide-react";
import { toast } from "sonner";

export function BackupDialog({ open, backupJson, onClose, onRestore, busy }) {
  const [tab, setTab] = useState("backup");
  const [restoreText, setRestoreText] = useState("");
  const tabCls = (t) =>
    `flex-1 rounded-md py-1.5 text-xs font-semibold uppercase tracking-wide transition-colors ${tab === t ? "bg-orange-500 text-white" : "bg-slate-100 text-slate-500 hover:text-slate-800"}`;
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent aria-describedby={undefined} className="border-slate-200 bg-white text-slate-900" data-testid="backup-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl uppercase tracking-wide">Backup & restore</DialogTitle>
        </DialogHeader>
        <div className="flex gap-2">
          <button data-testid="backup-tab-button" className={tabCls("backup")} onClick={() => setTab("backup")}>Backup</button>
          <button data-testid="restore-tab-button" className={tabCls("restore")} onClick={() => setTab("restore")}>Restore</button>
        </div>
        {tab === "backup" ? (
          <div className="space-y-3">
            <textarea
              data-testid="backup-json-textarea"
              readOnly
              value={backupJson || "Loading…"}
              className="h-40 w-full rounded-lg border border-slate-200 bg-slate-50 p-3 font-mono text-xs text-slate-700 outline-none"
            />
            <button
              data-testid="backup-copy-button"
              onClick={() => {
                navigator.clipboard.writeText(backupJson || "");
                toast.success("Backup JSON copied");
              }}
              className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-orange-500 py-2.5 text-sm font-semibold uppercase tracking-wide text-white transition-colors hover:bg-orange-400"
            >
              <Copy className="h-4 w-4" /> Copy JSON
            </button>
          </div>
        ) : (
          <div className="space-y-3">
            <textarea
              data-testid="restore-json-textarea"
              value={restoreText}
              onChange={(e) => setRestoreText(e.target.value)}
              placeholder="Paste backup JSON here…"
              className="h-40 w-full rounded-lg border border-slate-200 bg-slate-50 p-3 font-mono text-xs text-slate-700 outline-none focus:border-orange-400"
            />
            <button
              data-testid="restore-submit-button"
              disabled={busy || !restoreText.trim()}
              onClick={() => onRestore(restoreText)}
              className="w-full rounded-lg bg-orange-500 py-2.5 text-sm font-semibold uppercase tracking-wide text-white transition-colors hover:bg-orange-400 disabled:opacity-40"
            >
              {busy ? "Restoring…" : "Restore"}
            </button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
